import { AlertCircle, CheckCircle2 } from "lucide-react";

// Error / success strip shown above the fields. Renders nothing when both are
// empty so it never reserves space on a clean form.
const AuthBanner = ({ error, success }) => {
  if (!error && !success) return null;

  const isError = Boolean(error);
  const Icon = isError ? AlertCircle : CheckCircle2;

  return (
    <div
      role={isError ? "alert" : "status"}
      className={`mt-6 flex items-start gap-2.5 rounded-lg border px-3.5 py-3 text-sm ${
        isError
          ? "border-danger-200 bg-danger-50 text-danger-700"
          : "border-emerald-200 bg-emerald-50 text-emerald-700"
      }`}
    >
      <Icon size={16} className="mt-0.5 shrink-0" />
      <span>{error || success}</span>
    </div>
  );
};

export default AuthBanner;
